import en from './en';
import hy from './hy';

import errorsEn from './errors/en';
import errorsHy from './errors/hy';

export default {
  en: {
    ...en,
    errors: errorsEn,
  },

  hy: {
    ...hy,
    errors: errorsHy,
  },
};
